import { motion } from "framer-motion";
import React from "react";
import "./Pricing.css";
import TechIcon from "../../Utils/Icons/Icons";
import { plans, enterprisePlan } from "./pricingData";
import posthog from "posthog-js";

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2,
    },
  },
};

const cardVariants = {
  hidden: { x: -50, opacity: 0 },
  visible: { x: 0, opacity: 1, transition: { duration: 0.7, ease: "easeOut" } },
};

const enterpriseVariants = {
  hidden: { y: 50, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    transition: { duration: 0.7, delay: 0.2, ease: "easeOut" },
  },
};

const PricingPage = () => {
  const showPricingBtn = posthog.isFeatureEnabled("pricing_btn");
  return (
    <>
      <div className="pricingContainerWrapper">
        <div className="pricingContainer">
          <div className="header">
            <motion.h1
              initial={{ y: -50, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.6, ease: "easeOut" }}
            >
              Get started
              <br />
              for <span className="free">free</span>
            </motion.h1>
            <motion.p
              initial={{ y: -30, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.6, delay: 0.2, ease: "easeOut" }}
            >
              Get full access to Pune with a 30-day free trial. Unlimited
              integrations and users with each plan.
            </motion.p>
          </div>

          <div className="pricingMainSection">
            <motion.div
              className="pricingGrid"
              variants={containerVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.1 }}
            >
              {plans.map((plan, index) => (
                <motion.div
                  key={index}
                  className="planWrapper"
                  variants={cardVariants}
                >
                  <div className="pricingCard">
                    <div className="planName">{plan.name}</div>
                    <div className="priceWrapper">
                      <span className="price">
                        <span className="currency">$</span>
                        {plan.price.toLocaleString()}
                      </span>
                      <span className="period">{plan.period}</span>
                    </div>
                    <ul className="features">
                      {plan.features.map((feature, idx) => (
                        <li key={idx} className="featureItem">
                          <div className="checkIcon">
                            <TechIcon name="check" strokeWidth={3} />
                          </div>
                          {feature}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div className="cardBtnContainer">
                    <button
                      className={`cardBtn ${plan.buttonStyle}`}
                      disabled={!showPricingBtn}
                    >
                      {showPricingBtn ? plan.buttonText : "Coming Soon"}
                    </button>
                  </div>
                </motion.div>
              ))}
            </motion.div>

            <motion.div
              className="pricingCard enterprise"
              variants={enterpriseVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.1 }}
            >
              <div className="enterpriseContent">
                <div className="enterpriseLeft">
                  <div className="planName">{enterprisePlan.name}</div>
                  <div className="enterpriseDesc">
                    {enterprisePlan.description}
                  </div>
                  <div className="enterpriseFeats">
                    {enterprisePlan.features.map((feature, idx) => (
                      <div key={idx} className="featureItem">
                        <div className="checkIcon">
                          <TechIcon name="check" strokeWidth={3} />
                        </div>
                        {feature}
                      </div>
                    ))}
                  </div>
                </div>
                <div className="enterpriseRight">
                  <button
                    className={`cardBtn ${enterprisePlan.buttonStyle}`}
                    disabled={!showPricingBtn}
                  >
                    {showPricingBtn ? enterprisePlan.buttonText : "Coming Soon"}
                  </button>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PricingPage;
